import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const SISTEMA_PATH = "/app";

export const login = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/login`, body);
  return handleResponse(response);
};

export const executeQuery = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/execute`, body);
  return handleResponse(response);
};

export const executeUpdate = async ({ collection, nombreid, valorid }, data) => {
  const response = await HTTP_REQUEST.put(
    `${SISTEMA_PATH}/${collection}/${nombreid}/${valorid}`,
    data
  );
  return handleResponse(response);
};

export const marcarAsistencia = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/asistencia`, body);
  return handleResponse(response);
};

export const marcarAsistenciaParticipante = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/asistencia/participante`, body);
  return handleResponse(response);
};

export const marcarCarnetParticipante = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/carnet/participante`, body);
  return handleResponse(response);
};

export const marcarAsistenciaIngresante = async (body) => {
  const response = await HTTP_REQUEST.post(`${SISTEMA_PATH}/asistencia/ingresante`, body);
  return handleResponse(response);
};

export const consultaEncuesta = async (nrodocumento) => {
  try {
    const response = await fetch(process.env.REACT_APP_ENCUESTA_URL + nrodocumento, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          window.btoa(
            process.env.REACT_APP_ENCUESTA_USUARIO + ":" + process.env.REACT_APP_ENCUESTA_TOKEN
          )
      }
    });

    if (response.status === 200) {
      return response.json();
    } else {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    console.error(error);
  }
};
